import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getCacheGroupMetricsFilterOptions;

const DBO_METRICS_FILTER_OPTIONS_QUERY_KEY = 'dbo-metrics-filter-options';

const getMetricsFilterOptionsQueryKey = ({
  cacheGroupId,
}: { cacheGroupId?: string } = {}) =>
  [DBO_METRICS_FILTER_OPTIONS_QUERY_KEY, cacheGroupId] as const;

const getMetricsFilterOptionsQueryOptions = ({
  cacheGroupId,
  enabled,
}: {
  cacheGroupId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getMetricsFilterOptionsQueryKey({ cacheGroupId }),
    queryFn: async () => {
      const { data } = await apiFn({ id: cacheGroupId! });
      return data;
    },
    enabled: makeIsEnabled(!!cacheGroupId, enabled),
  });

export const useMetricsFilterOptionsQuery = ({
  cacheGroupId,
  enabled,
}: {
  cacheGroupId?: string;
  enabled?: boolean;
}) => {
  return useQuery(
    getMetricsFilterOptionsQueryOptions({
      cacheGroupId,
      enabled,
    })
  );
};
